const firebaseConfig = {
    apiKey: "AIzaSyAgJcjbqfzEJeeUXhYphe-KzvVaW4bZMEs",
    authDomain: "ab-health-care-a93d0.firebaseapp.com",
    projectId: "ab-health-care-a93d0",
    storageBucket: "ab-health-care-a93d0.appspot.com",
    messagingSenderId: "11787637399",
    appId: "1:11787637399:web:103c201d0ab9b630accfd2"
};
export default firebaseConfig;
